import { render, staticRenderFns } from "./Generic_Holding_Page.vue?vue&type=template&id=1bdbf088&scoped=true"
import script from "./Generic_Holding_Page.vue?vue&type=script&lang=js"
export * from "./Generic_Holding_Page.vue?vue&type=script&lang=js"
import style0 from "./Generic_Holding_Page.vue?vue&type=style&index=0&id=1bdbf088&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdbf088",
  null
  
)

export default component.exports